<div
  class="ai-chatbot-layout"
  [class.ai-chatbot-layout-split]="
    !!aiChatbotService.selectedTemplateTunerPreview()
  "
>
  <div class="ai-chatbot-messages-container">
    <div class="ai-chatbot-header">
      <!-- Removed until a decision is made on the avatar -->
      <!-- <div class="ai-chatbot-header-left">
        <img
          class="ai-chatbot-avatar"
          src=""
          title=""
        />
        <span class="ai-chatbot-header-title"></span>
      </div> -->
      <div class="ai-chatbot-header-restart">
        <button
          matButton="outlined"
          class="ai-chatbot-header-restart-button"
          (click)="restartSession()"
          tabindex="0"
          [hidden]="aiChatbotService.isMessagesEmpty()"
        >
          <mat-icon svgIcon="restart" aria-hidden="true"></mat-icon>
          Restart Chat
        </button>
      </div>
      <ai-chatbot-credits-menu></ai-chatbot-credits-menu>
    </div>

    <div class="ai-chatbot-chat-container">
      @if (aiChatbotService.isMessagesEmpty()) {
        <div class="ai-chatbot-chat-hero-overlay">
          <div class="ai-chatbot-lets-make-container">
            <h1 class="ai-chatbot-lets-make">
              Create your perfect
              <br class="ai-chatbot-lets-make-break" />presentation!
            </h1>
          </div>

          <div
            class="tw-flex tw-flex-col sm:!tw-flex-row tw-justify-center tw-items-center tw-gap-4 tw-pt-2 tw-pb-10"
          >
            <a
              matButton="outlined"
              class="tw-w-80 tw-rounded-full"
              uiSref="apps.editor.create"
            >
              <mat-icon
                svgIcon="layout"
                aria-hidden="true"
                class="tw-text-green-600"
              ></mat-icon>
              <span>Search Templates</span>
            </a>
            <button
              mat-flat-button
              color="primary"
              class="tw-w-80 tw-rounded-full ai-button"
              (click)="focusPromptBoxInput()"
            >
              <mat-icon
                svgIcon="ai"
                class="filled"
                aria-hidden="true"
              ></mat-icon>
              <span>Generate with AI</span>
            </button>
          </div>
        </div>
      }

      <ai-chatbot-chat-scroll
        [class.ai-chatbot-chat-scroll-empty]="
          aiChatbotService.isMessagesEmpty()
        "
        [messages]="aiChatbotService.currentSession()?.messages() || []"
        [isProcessing]="aiChatbotService.isProcessing"
        [isLoadingTemplates]="aiChatbotService.isLoadingTemplates"
        (selectedTemplateIdxChange)="selectedTemplateIdx = $event"
      ></ai-chatbot-chat-scroll>

      <ai-chatbot-prompt-box
        [class.ai-chatbot-prompt-box-empty]="aiChatbotService.isMessagesEmpty()"
        [initialPrompt]="initialPrompt"
        [focus]="focusPromptInput"
        [class.ai-chatbox-empty-messages]="aiChatbotService.isMessagesEmpty()"
      ></ai-chatbot-prompt-box>
    </div>
  </div>
  <div
    class="ai-chatbot-single-preview-container"
    [class.ai-chatbot-single-preview-container-visible]="
      !!aiChatbotService.selectedTemplateTunerPreview()
    "
  >
    @for (
      preview of [aiChatbotService.selectedTemplateTunerPreview()];
      track preview?.messageId + '-' + preview?.optionIndex
    ) {
      @if (preview) {
        <template-tuner-preview
          [presentation]="preview.presentation"
          [optionNumber]="preview.optionIndex + 1"
        />
      }
    }
  </div>
</div>

<div class="ai-chatbot-prompt-terms">
  <span>
    Rise Vision AI can make mistakes. Please check for accuracy.
    <a
      href="https://help.risevision.com/hc/en-us/articles/360000924446-Software-Terms-of-Service"
      target="_blank"
      rel="noopener noreferrer"
    >
      See terms
    </a>
  </span>
</div>
